import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '@microsoft/microsoft-graph-types-beta';
import { DefaultDataService, HttpUrlGenerator, Logger } from '@ngrx/data';

import { EMPTY, Observable } from 'rxjs';
import { expand, reduce } from 'rxjs/operators';

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
};

interface GraphUsersResponse {
    value: [User];
    '@odata.nextLink'?: string;
}

function parseToken(response: GraphUsersResponse): string | false {
    let skiptoken: string | false = false;
    if (response['@odata.nextLink']) {
        skiptoken = response['@odata.nextLink'].split('skiptoken=')[1];
    }
    return skiptoken;
}

@Injectable()
export class UserDataService extends DefaultDataService<User[]> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, logger: Logger) {
        super('User', http, httpUrlGenerator);
    }

    private fetchWithPaging<T>(msp: string, tenant: string): Observable<any[]> {
        return this.http
            .get(`/api/microsoft/graph/users?$select=id,userPrincipalName`, {
                headers: {
                    ...headers,
                    'msp-id': msp,
                    'tenant-id': tenant,
                },
            })
            .pipe(
                expand((data: any) => {
                    const token = parseToken(data);
                    if (token) {
                        return this.http.get<T[]>(
                            `/api/microsoft/graph/users?$skiptoken=${token}&$select=id,userPrincipalName`,
                            {
                                headers: {
                                    ...headers,
                                    'msp-id': msp,
                                    'tenant-id': tenant,
                                },
                            },
                        );
                    } else {
                        return EMPTY;
                    }
                }),
                reduce((acc, data: any) => {
                    return acc.concat(data.value);
                }, []),
            );
    }

    override getWithQuery(params: { msp: string; tenant: string }) {
        const { msp, tenant } = params;
        return this.fetchWithPaging<User[]>(msp, tenant);
    }
}
